import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { from, of } from 'rxjs';
import {catchError, concatMap, map} from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as MarketActions from './market.action';
import { Action } from 'rxjs/internal/scheduler/Action';
import { MarketState } from './market.reducer';
import { MainService } from '../services/main.service';
import { Web3Service } from '../services/web3.service';
import { AuthService } from '../services/auth.service';
import { CookieService } from '../services/cookie.service';
import { ToastService } from 'angular-toastify';
var moment = require('moment-timezone');

@Injectable()
export class MarketEffects {
  tutorial:number=0;
  wallet:string='';
   constructor(
    private actions$: Actions,
    private store: Store<MarketState>,
    private mainService: MainService,
    private web3:Web3Service,
    private authService:AuthService,
    private cookie:CookieService,
    private toastr:ToastService
  ) {}

  login = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.login),
      concatMap((action: any) => from(this.web3.initWeb3()).pipe(
        map((data: any) =>{
            if(data.error){
                return MarketActions.loginFail({error:{message:"ERROR OCCURED ON WALLET CONNECT."}});
            }
            this.wallet = data.wallet;
            this.store.dispatch(MarketActions.getUser({address:data.wallet}));
            return MarketActions.loginSuccess({wallet: data.wallet, allow:data.allow});
        }),
        catchError((error) => {
          console.log(error)
          return of(MarketActions.loginFail({error}));
        })

        )
      )
    );
    }
  );
 
  packs= createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.packs),
      concatMap((action: any) => this.mainService.getPacks(action.data).pipe(
        map((data: any) => {
          return MarketActions.packsSuccess({packs:data.packs});
        }),
        catchError((error) => {
          this.toastr.error(error.error.message)
          return of(MarketActions.packsFail({error}));
        })

        )
      )
    );
    }
  );

  getETH= createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.eth),
      concatMap((action: any) => this.mainService.getETH(action.data).pipe(
        map((data: any) => {
          return MarketActions.ethSuccess({eth:data.eth});
        }),
        catchError((error) => {
          this.toastr.error(error.error.message)
          return of(MarketActions.ethFail({error}));
        })

        )
      )
    );
    }
  );

  passSignature = createEffect(() =>{
    return this.actions$.pipe(
      ofType(MarketActions.passSignature),
      concatMap((action: any) => this.mainService.getPassSig(action.userId, action.ids).pipe(
        map((data: any) => {
         
          this.store.dispatch(MarketActions.burnPass({signature:data.signature, tokens:action.ids, season:action.season,  userId:action.userId}));
          return MarketActions.passSignatureSuccess({
            signature: data.signature
          })
        }
        ),
        catchError((error) => {
          this.toastr.error(error.error.message);
          return of(MarketActions.passSignatureFail({error}));
        })

        )
      )
    );
  });

  packSignature = createEffect(() =>{
    return this.actions$.pipe(
      ofType(MarketActions.packSignature),
      concatMap((action: any) => this.mainService.packSignature(action.userId, action.typeP, action.quantity).pipe(
        map((data: any) => {
         
          this.store.dispatch(MarketActions.packInteraction({sig:data.signature, userId:action.userId, typeP:action.typeP, quantity:action.quantity}));
          return MarketActions.packSignatureSuccess({
            signature: data
          })
        }
        ),
        catchError((error) => {
          this.toastr.error(error.error.message);
          return of(MarketActions.packSignatureFail({error}));
        })

        )
      )
    );
  });

  opensea = createEffect(() =>{
    return this.actions$.pipe(
      ofType(MarketActions.opensea),
      concatMap((action: any) => this.mainService.opensea(action.tokenId).pipe(
        map((data: any) => {
         
          //this.store.dispatch(MarketActions.packInteraction({sig:data.signature, userId:action.userId, typeP:action.typeP, quantity:action.quantity}));
          return MarketActions.openseaSuccess({
            data: data
          })
        }
        ),
        catchError((error) => {
          this.toastr.error(error.error.message);
          return of(MarketActions.openseaFail({error}));
        })

        )
      )
    );
  });

  packInteraction = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.packInteraction),
      concatMap((action: any) => from(this.web3.packInteraction(action.sig, action.userId, action.typeP, action.quantity)).pipe(
        map((data: any) =>{
            if(data.error){
                return MarketActions.packInteractionFail({error:{message:"ERROR OCCURED ON WALLET CONNECT."}});
            }
            console.log(this.wallet)
            console.log(data)
            //this.store.dispatch(MarketActions.getNfts({data:data.wallet}));
            this.store.dispatch(MarketActions.packs({data:action.userId}));
            return MarketActions.packInteractionSuccess({pack: data});
        }),
        catchError((error) => {
          return of(MarketActions.packInteractionFail({error}));
        })

        )
      )
    );
    }
  );

  approval = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.checkApproval),
      concatMap((action: any) => from(this.web3.checkApproval()).pipe(
        map((data: any) =>{
            if(data.error){
                return MarketActions.checkApprovalFail({error:{message:"ERROR OCCURED ON WALLET CONNECT."}});
            }
            //this.store.dispatch(MarketActions.getNfts({data:data.wallet}));
            
            return MarketActions.checkApprovalSuccess({approval: data});
        }),
        catchError((error) => {
          return of(MarketActions.checkApprovalFail({error}));
        })

        )
      )
    );
    }
  );

  packOpen = createEffect(() =>{
    return this.actions$.pipe(
      ofType(MarketActions.packOpen),
      concatMap((action: any) => this.mainService.packOpen(action.tokenId,action.userId).pipe(
        map((data: any) => {
         
          this.store.dispatch(MarketActions.packs({data:action.userId}));
          this.store.dispatch(MarketActions.opensea({tokenId:action.tokenId}));
          return MarketActions.packOpenSuccess({
            card: data.card
          })
        }
        ),
        catchError((error) => {
          this.toastr.error(error.error.message);
          return of(MarketActions.packOpenFail({error}));
        })

        )
      )
    );
  });

  upgradeNFT = createEffect(() =>{
    return this.actions$.pipe(
      ofType(MarketActions.upgradeNFT),
      concatMap((action: any) => this.mainService.upgradeNFT(action.tokenId,action.userId).pipe(
        map((data: any) => {
          this.store.dispatch(MarketActions.myinventory({userId:action.userId}));
          this.store.dispatch(MarketActions.packs({data:action.userId}));
          this.store.dispatch(MarketActions.opensea({tokenId:action.tokenId}));
          return MarketActions.upgradeNFTSuccess({
            card: data.card
          })
        }
        ),
        catchError((error) => {
          this.toastr.error(error.error.message);
          return of(MarketActions.upgradeNFTFail({error}));
        })

        )
      )
    );
  });

  handleDiscordData = createEffect(() =>{
    return this.actions$.pipe(
      ofType(MarketActions.discordData),
      concatMap((action: any) => this.authService.getDiscordData(action.code, action.userId).pipe(
        map((data: any) => {

          /*if(data){
            this.cookie.setCookie('token',data.data.access_token, data.data.expires_in);
          }*/
         
          this.store.dispatch(MarketActions.getUser({address:data.user.wallet}));
          return MarketActions.discordDataSuccess({
            Discord: data
          })
        }
        ),
        catchError((error) => {
          this.toastr.error(error.error.message);
          return of(MarketActions.discordDataFail({error}));
        })

        )
      )
    );
  });

  seasons= createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.getSeasons),
      concatMap((action: any) => this.mainService.getSeasons().pipe(
        map((data: any) => {
          if(data.season?.Rewards.length > 0){
            data.season.Rewards.sort((a,b)=>{
              return Number(a.LevelReq)-Number(b.LevelReq);
            });
          }

          return MarketActions.getSeasonsSuccess({
            season: data.season,
            pastSeason:data.past
          })
        }),
        catchError((error) => {
          this.toastr.error(error.error.message);
          return of(MarketActions.getSeasonsFail({error}));
        })

        )
      )
    );
    }
  );

  logout = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.logout),
      concatMap((action: any) => from(this.web3.logout()).pipe(
        map((data: any) =>{
            if(data.error){
              this.toastr.error("ERROR OCCURED ON WALLET DISCONNECT.");
                return MarketActions.logoutFail({error:{message:"ERROR OCCURED ON WALLET DISCONNECT."}});
            }
            this.store.dispatch(MarketActions.login({provider:null}));
            return MarketActions.logoutSuccess({wallet: data});
        }),
        catchError((error) => {
          this.toastr.error(error.error.message);
          return of(MarketActions.logoutFail({error}));
        })

        )
      )
    );
    }
  );

  loadUser= createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.getUser),
      concatMap((action: any) => this.mainService.getUser(action.address).pipe(
        map((data: any) => {
   
          let current = 1;
          if(data.user.UserSkills.length > 0){
            let gang = data.user.UserSkills.find((val)=>{
              return val.SkillName === 'Gang Level';
            });
         
            current = gang?.currentLevel;
          }
         
          data.user.CurrentLevel = current;
          this.store.dispatch(MarketActions.eth({data:data.user.Id}));
          this.store.dispatch(MarketActions.getNfts({data:data.user.Id}));
          this.store.dispatch(MarketActions.packs({data:data.user.Id}));
          this.store.dispatch(MarketActions.getTokens({address:data.user.Wallets}));
          this.store.dispatch(MarketActions.levels({data:null}));
          this.store.dispatch(MarketActions.myinventory({userId:data.user.Id}))
          //this.store.dispatch(MarketActions.checkApproval({data:null}));
          return MarketActions.getUserSuccess({
            user: data.user,
            missionsComp:data.missionsComp,
            allSkills:data.allSkills,
            pass:data.burnpass,
            passrewards:data.burnRewards,
            userSeasonRewards:data.userSeasonRewards,
            packSigs:data.packSig
          })
        }),
        catchError((error) => {
          this.toastr.error(error.error.message);
          return of(MarketActions.getUserFail({error}));
        })

        )
      )
    );
    }
  );

  levels= createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.levels),
      concatMap((action: any) => this.mainService.levels().pipe(
        map((data: any) => {
       
          return MarketActions.levelsSuccess({
            levels: data.levels
          })
        }),
        catchError((error) => {
          this.toastr.error(error.error.message);
          return of(MarketActions.levelsFail({error}));
        })

        )
      )
    );
    }
  );

  updateAvatar= createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.updateAvatar),
      concatMap((action: any) => this.mainService.updateAvatar(action.id, action.url, action.username).pipe(
        map((data: any) => {
          this.store.dispatch(MarketActions.getUser({address:action.address}))
          return MarketActions.updateAvatarSuccess({
            status: data,
          })
        }),
        catchError((error) => {
          this.toastr.error(error.error.message)
          return of(MarketActions.updateAvatarFail({error}));
        })

        )
      )
    );
    }
  );

  allMissions= createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.getAllMissions),
      concatMap((action: any) => this.mainService.getAllMissions(action.data).pipe(
        map((data: any) => {
          //Add seconds
          data.missions.forEach(element => {
            let seconds = this.getTime(element.EndDate);
            let days = this.getDays(element.EndDate);
            element.seconds = seconds;
            element.days = days;

            if(element.CrewStage === 1){
              let crewseconds = this.getTime(element.StartDate);
              let crewdays = this.getDays(element.StartDate);
              element.crewseconds = crewseconds;
              element.crewdays = crewdays;
            }
          });

          /*this.store.dispatch(MarketActions.getTopWinners({data:null}));*/
          return MarketActions.getAllMissionsSuccess({
            missions: data.missions
          })
        }),
        catchError((error) => {
          this.toastr.error(error.error.message)
          return of(MarketActions.getAllMissionsFail({error}));
        })

        )
      )
    );
    }
  );

  myMissions= createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.getMyMissions),
      concatMap((action: any) => this.mainService.getMyMissions(action.userId).pipe(
        map((data: any) => {
          //Add seconds
          data.missions.forEach(element => {
            let seconds = this.getTime(element.EndDate);
            let days = this.getDays(element.EndDate);
            element.seconds = seconds;
            element.days = days;
            if(element.CrewStage === 1){
              let crewseconds = this.getTime(element.StartDate);
              let crewdays = this.getDays(element.StartDate);
              element.crewseconds = crewseconds;
              element.crewdays = crewdays;
            }
          });

          console.log(data.missions)

          return MarketActions.getMyMissionsSuccess({
            myMissions: data.missions
          })
        }),
        catchError((error) => {
          this.toastr.error(error.error.message)
          return of(MarketActions.getMyMissionsFail({error}));
        })

        )
      )
    );
    }
  );

  deploy= createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.deployToMission),
      concatMap((action: any) => this.mainService.deployToMissions(action.userId,action.soldier, action.items).pipe(
        map((data: any) => {
          this.store.dispatch(MarketActions.getAllMissions({data:null}));
          return MarketActions.deployToMissionSuccess({
            missions: data
          })
        }),
        catchError((error) => {
          this.toastr.error(error.error.message)
          return of(MarketActions.deployToMissionFail({error}));
        })

        )
      )
    );
    }
  );

  desert= createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.desertMission),
      concatMap((action: any) => this.mainService.desertMissions(action.userId,action.mission).pipe(
        map((data: any) => {
          this.store.dispatch(MarketActions.getMyMissions({userId:action.userId}));
          
          return MarketActions.desertMissionSuccess({
            missions: data
          })
        }),
        catchError((error) => {
          this.toastr.error(error.error.message)
          return of(MarketActions.desertMissionFail({error}));
        })

        )
      )
    );
    }
  );

  claim= createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.claimReward),
      concatMap((action: any) => this.mainService.claim(action.userId,action.missionId).pipe(
        map((data: any) => {
          this.store.dispatch(MarketActions.getMyMissions({userId:action.userId}));
          
          this.store.dispatch(MarketActions.getUser({address:this.wallet}));
          return MarketActions.claimRewardSuccess({
            claim: data.missions
          })
        }),
        catchError((error) => {
          this.toastr.error(error.error.message)
          return of(MarketActions.claimRewardFail({error}));
        })

        )
      )
    );
    }
  );

  claimPassRewards= createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.claimPassReward),
      concatMap((action: any) => this.mainService.claimRewards(action.userId,action.rewardId).pipe(
        map((data: any) => {
          this.toastr.success("Pass Rewards Claimed");
          
          this.store.dispatch(MarketActions.getUser({address:this.wallet}));
          return MarketActions.claimPassRewardSuccess({
            pass: data.burnpass,
            passrewards:data.burnRewards,
            myInventory:data.items
          })
        }),
        catchError((error) => {
          this.toastr.error(error.error.message)
          return of(MarketActions.claimPassRewardFail({error}));
        })

        )
      )
    );
    }
  );

  claimSeasonRewards= createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.claimSeasonReward),
      concatMap((action: any) => this.mainService.claimSeasonRewards(action.userId).pipe(
        map((data: any) => {
          this.toastr.success("Season Rewards Claimed");
          
          this.store.dispatch(MarketActions.getUser({address:this.wallet}));
          return MarketActions.claimSeasonRewardSuccess({
            userSeasonRewards: data.userSeasonRewards,
            myInventory:data.items
          })
        }),
        catchError((error) => {
          this.toastr.error(error.error.message)
          return of(MarketActions.claimSeasonRewardFail({error}));
        })

        )
      )
    );
    }
  );

  getNFTs= createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.getNfts),
      concatMap((action: any) => this.mainService.getNFTs(action.data).pipe(
        map((data: any) => {
          return MarketActions.getNftsSuccess({Nfts: data});
        }),
        catchError((error) => {
          this.toastr.error(error.error.message)
          return of(MarketActions.getNftsFail({error}));
        })

        )
      )
    );
    }
  );

  inventory = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.inventory),
      concatMap((action: any) => from(this.mainService.getInventory()).pipe(
        map((data: any) =>{
          
           // this.store.dispatch(MarketActions.getUser({address:action.address}));
            return MarketActions.inventorySuccess({inventory:data.inventorys});
        }),
        catchError((error) => {
          this.toastr.error(error.error.message);
          return of(MarketActions.inventoryFail({error}));
        })

        )
      )
    );
    }
  );

  myInventory = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.myinventory),
      concatMap((action: any) => from(this.mainService.myInventory(action.userId)).pipe(
        map((data: any) =>{
          //this.toastr.success("Purchase Successful!");
           // this.store.dispatch(MarketActions.getUser({address:action.address}));
            return MarketActions.myinventorySuccess({myinventory:data.myInventory, userSell:data.userSell});
        }),
        catchError((error) => {
          this.toastr.error(error.error.message);
          return of(MarketActions.myinventoryFail({error}));
        })

        )
      )
    );
    }
  );

  purchaseInventory = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.purchaseInventory),
      concatMap((action: any) => from(this.mainService.purchaseInventory(action.userId, action.inventoryId, action.quantity)).pipe(
        map((data: any) =>{
          this.toastr.success("Purchase Successful!");
           this.store.dispatch(MarketActions.getUser({address:data.address}));
            return MarketActions.purchaseInventorySuccess({myinventory:data});
        }),
        catchError((error) => {
          this.toastr.error(error.error.message);
          return of(MarketActions.purchaseInventoryFail({error}));
        })

        )
      )
    );
    }
  );

  burnPass = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.burnPass),
      concatMap((action: any) => from(this.web3.burnNFT(action.signature, action.tokens, action.season, action.userId)).pipe(
        map((data: any) =>{
            if(data.error){
                return MarketActions.burnPassFail({error:{message:"ERROR OCCURED BURNING."}});
            }

            this.store.dispatch(MarketActions.getUser({address:data}));
            //this.store.dispatch(MarketActions.stakeNfts({data:data}));
            return MarketActions.burnPassSuccess({pass: data});
        }),
        catchError((error) => {
          return of(MarketActions.burnPassFail({error}));
        })

        )
      )
    );
    }
  );

  scoreboard = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.scoreboard),
      concatMap((action: any) => from(this.mainService.scoreboard(action.data, action.userId)).pipe(
        map((data: any) =>{
          //this.toastr.success("Item applied Successful!");
           // this.store.dispatch(MarketActions.getUser({address:action.address}));
            return MarketActions.scoreboardSuccess({scores:data.leaders, userScore:data.userScore});
        }),
        catchError((error) => {
          this.toastr.error(error.error.message);
          return of(MarketActions.scoreboardFail({error}));
        })

        )
      )
    );
    }
  );

  setNav = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.setNav),
      map((action: any) => {
        return MarketActions.setNavSuccess({isNav:action.data});
      }
    )
    )
  });

  closeModal = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.closeModal),
      map((action: any) => {
        return MarketActions.closeModalSuccess({data:action.data});
      }
    )
    )
  });

  mobileMenu = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.mobileMenu),
      map((action: any) => {
        return MarketActions.mobileMenuSuccess({data:action.data});
      }
    )
    )
  });

  showProfileEdit = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.showProfileEdit),
      map((action: any) => {
        return MarketActions.showProfileEditSuccess({data:action.data});
      }
    )
    )
  });

  setDetail = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.selectDetails),
      map((action: any) => {
        return MarketActions.selectDetailsSuccess({data:action.data});
      }
    )
    )
  });

  setPack = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.selectPack),
      map((action: any) => {
        return MarketActions.selectPackSuccess({data:action.data});
      }
    )
    )
  });

  myMissionDetails = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.myMissionDetails),
      map((action: any) => {
        return MarketActions.myMissionDetailsSuccess({onMissions:action.onMissions, claimable:action.claimable});
      }
    )
    )
  });
  
  popup = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.popup),
      map((action: any) => {
        return MarketActions.popupSuccess({pop:action.pop});
      }
    )
    )
  });

  setFilters = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.setFilter),
      map((action: any) => {
        return MarketActions.setFilterSuccess({filter:action.filter});
       
      }
    )
    )
  });

  runFilters = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.missionsFilter),
      map((action: any) => {
        
        if(action.filter.AvailableMissions){
          let missFilter = action.missions.filter((ms)=>{
            
            return ms.Entries > ms.MissionCrew.length;
          });
          return MarketActions.missionsFilterSuccess({missions:missFilter, filter:action.filter});
        }
        else if(action.filter.AllMissions){
 
          return MarketActions.missionsFilterSuccess({missions:action.missions, filter:action.filter});
        }
        else if(action.filter.OnMissions){
         
          let missFilter = action.missions.filter((ms)=>{
            let hasMyCrew = ms.MissionCrew.find((mc)=>{
              return mc.UserId === action.userId;
            })
            console.log(hasMyCrew)
            return hasMyCrew && !ms.HasEnded;
          });
     
          return MarketActions.missionsFilterSuccess({missions:missFilter, filter:action.filter});
        }
        else if(action.filter.Claimable){
         
          let missFilter = action.missions.filter((ms)=>{
            
            return !ms.Claimed;
          });
     
          return MarketActions.missionsFilterSuccess({missions:missFilter, filter:action.filter});
        }
      }
    )
    )
  });

  purchaseSell = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.purchaseSell),
      concatMap((action: any) => from(this.mainService.purchaseSellItem(action.userId, action.userSell)).pipe(
        map((data: any) =>{
          this.toastr.success("Purchase Successful!");
           this.store.dispatch(MarketActions.myinventory({userId:action.userId}));
           this.store.dispatch(MarketActions.allSell({data:null}));
            return MarketActions.purchaseSellSuccess({data:null});
        }),
        catchError((error) => {
          this.toastr.error(error.error.message);
          return of(MarketActions.purchaseSellFail({error}));
        })

        )
      )
    );
    }
  );

  listSell = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.listSell),
      concatMap((action: any) => from(this.mainService.listSellItem(action.userId, action.userItemId, action.price)).pipe(
        map((data: any) =>{
          this.toastr.success("Listing Successful!");
           this.store.dispatch(MarketActions.myinventory({userId:action.userId}));
           this.store.dispatch(MarketActions.allSell({data:null}));
            return MarketActions.listSellSuccess({data:null});
        }),
        catchError((error) => {
          this.toastr.error(error.error.message);
          return of(MarketActions.listSellFail({error}));
        })

        )
      )
    );
    }
  );

  cancelSell = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.cancelSell),
      concatMap((action: any) => from(this.mainService.cancelSellItem(action.userId, action.sell)).pipe(
        map((data: any) =>{
          this.toastr.success("Cancel Successful!");
           this.store.dispatch(MarketActions.myinventory({userId:action.userId}));
           this.store.dispatch(MarketActions.allSell({data:null}));
            return MarketActions.cancelSellSuccess({data:null});
        }),
        catchError((error) => {
          this.toastr.error(error.error.message);
          return of(MarketActions.cancelSellFail({error}));
        })

        )
      )
    );
    }
  );

  allSell = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.allSell),
      concatMap((action: any) => from(this.mainService.allSell()).pipe(
        map((data: any) =>{
          console.log(data)
            return MarketActions.allSellSuccess({allSell:data.allSell});
        }),
        catchError((error) => {
          console.log(error)
          this.toastr.error(error.error.message);
          return of(MarketActions.allSellFail({error}));
        })

        )
      )
    );
    }
  );

  shareprofile = createEffect(() => {
    return this.actions$.pipe(
      ofType(MarketActions.shareprofile),
      map((action: any) => {
        return MarketActions.shareprofileSuccess({data:action.data});
      }
    )
    )
  });

  getTime(date:any){
    if(!date){
      return '0';
    }
    var d = new Date();
    var dP = new Date(date);
    var myDatetimeFormat= "YYYY-MM-DD hh:mm:ss A";
    var myDatetimeString = moment.utc(d).format(myDatetimeFormat);/// tz(myTimezone).format(myDatetimeFormat);
    var myDatetimeStringPost = moment.utc(dP).format(myDatetimeFormat);
    let duration = moment.duration(moment(myDatetimeStringPost).diff(moment(myDatetimeString)));

    if(moment(myDatetimeString).isSameOrAfter(moment(myDatetimeStringPost))){
      return 0;
    }
    let seconds = duration.asSeconds();
  
    return !seconds || seconds > 0 ? seconds  : '0';
  }

  getDays(date:any){
    if(!date){
      return '0';
    }
    var d = new Date();
    var dP = new Date(date);
    var myDatetimeFormat= "YYYY-MM-DD hh:mm:ss A";
    var myDatetimeString = moment.utc(d).format(myDatetimeFormat);/// tz(myTimezone).format(myDatetimeFormat);
    var myDatetimeStringPost = moment.utc(dP).format(myDatetimeFormat);
    let duration = moment.duration(moment(myDatetimeStringPost).diff(moment(myDatetimeString)));
   
    if(moment(myDatetimeString).isSameOrAfter(moment(myDatetimeStringPost))){
      return 0;
    }
    let seconds = duration.asSeconds();
 
    return !seconds || seconds > 0 ? Math.floor(seconds/60/60/24)  : 0;
  }

}